import API from 'services/api';

export const getProfileRoles = () => API.get('/api/profile/roles').then(response => response?.data);
